import script from "./back-row.vue?vue&type=script&setup=true&lang=js"
export * from "./back-row.vue?vue&type=script&setup=true&lang=js"

import "./back-row.vue?vue&type=style&index=0&id=73ef57f2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73ef57f2"]])

export default __exports__